// @flow

import { LkTypeDialog } from './lkType';
import { default as server2 } from 'server2';

export class LkTypeDialogController {

	_dialog;

	juridicalCompaniesReq = (creds) => server2.my.rest.post(
		[ 'juridical', 'companies', 'byUser' ],
		{
			body: {...creds}
		}
	);

	async _showLkTypeModal (init: {
		credentials: { email: string, password: string },
		callback: () => void
	}) {
		// TODO: search for a proper Response unwrapper in codebase here
		let juridicalCompaniesList;
		try {
			let juridicalCompaniesResponse = await this.juridicalCompaniesReq(init.credentials);
			if (juridicalCompaniesResponse.responseJSON.Data.status === 'forbidden') {
				throw new Error('403');
			}
			juridicalCompaniesList = juridicalCompaniesResponse.responseJSON.Data.Items;
		} catch(e) {
			throw e;
		}
		this._dialog = new LkTypeDialog({
			companies: juridicalCompaniesList,
			creds: init.credentials,
			onSubmitClick: init.callback
		});
		this._dialog.init()
		.show();
	}
}
